import { render, staticRenderFns } from "./detailProducts.vue?vue&type=template&id=85a000a2&"
import script from "./detailProducts.vue?vue&type=script&lang=js&"
export * from "./detailProducts.vue?vue&type=script&lang=js&"
import style0 from "./detailProducts.vue?vue&type=style&index=0&id=85a000a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports